<template>
  <v-layout
    class="w-100 pt-10 pb-5"
  >
    <v-container>
      <h2 class="v-row-title display-1 text-center mb-2">{{$t('page.markets.title')}}</h2>
      <p class="subtitle-1 font-weight-light text-center">{{$t('page.markets.overline')}} </p>
      <v-row>
        <v-col
          v-for="(market) in listMarkets"
          :key="market.key"
        >
          <v-card
            outline
            :elevation="0"
            :class="`card-market opa-${market.key.toLowerCase()} w-100 h-100 py-6 px-4`"
          >
            <div class="d-flex align-center text-center w-100 h-100 mx-auto">
              <div class="d-flex flex-column text-center w-100 h-100">
                <market-icons center=" mx-auto" :spacing="false" :items="[market.key]" />
                <h3 class="v-row-title title mb-3 mt-6">
                  {{ market[`name_${$i18n.locale.split('-')[0]}`] }}
                </h3>
                <v-card-actions class="pa-0 mt-auto mx-auto">
                  <v-btn
                    link
                    :color="market.color"
                    :to="{
                      name: 'SingleMarkets', params: { market: market.key.toLowerCase() }
                    }"
                  >
                    {{ $tc('theme.documentCount', [market.count]) }}
                  </v-btn>
                </v-card-actions>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>
<script>
import MarketIcons from '@/components/file/Markets'
export default {
  name: 'block-markets',
  components: {
    MarketIcons
  },
  computed: {
    listMarkets () {
      const markets = this.$store.getters["home/termsType"]('markets')
      return markets
    }
  },
}
</script>
<style>
.card-market {
  min-height: 240px;
}
.card-market .theme--light.v-btn {
  color: #fff
}
</style>
